import { formatDataValue } from 'utils/formatFns';
import { findEventObject } from '../utils/utils';

export const transportationDataFields = {
  deliveryCarrier: {
    label: 'Delivery Carrier',
    getValue: (_, transportationData) =>
      findEventObject(transportationData, 'departure', 'On Truck for Delivery')?.carrierName,
    formatValue: (value) => formatDataValue({ value }),
  },
  deliveryDestination: {
    label: 'Delivery Destination',
    getValue: (_, transportationData) =>
      findEventObject(transportationData, 'arrival', 'Arrival at Dealership')?.destination,
    formatValue: (value) => formatDataValue({ value }),
  },
  deliveryOrigin: {
    label: 'Delivery Origin',
    getValue: (_, transportationData) =>
      findEventObject(transportationData, 'arrival', 'Arrival at Dealership')?.origin,
    formatValue: (value) => formatDataValue({ value }),
  },
  truckDestination: {
    label: 'Truck Destination',
    getValue: (_, transportationData) =>
      findEventObject(transportationData, 'departure', 'On Truck for Delivery')?.destination,
    formatValue: (value) => formatDataValue({ value }),
  },
  vdcRailheadDestination: {
    label: 'VDC Railhead - Destination',
    getValue: (_, transportationData) =>
      findEventObject(transportationData, 'departure', 'Rail Depart')?.destination,
    formatValue: (value) => formatDataValue({ value }),
  },
};
